export { AnimMockUiSuccess } from "./AnimMockUiSuccess";
export type { AnimMockUiSuccessProps } from "./AnimMockUiSuccess";
